import React from "react";
import styled, { withTheme } from "styled-components";
import RectangleImage from "./device-rectangle";
import DeviceImage from "./device-illustration";
import A11yDialog from "a11y-dialog";
import Portal from "../../../components/portal";
import DownloadAppUI from "./download-app-ui";
import SimplifiedReaderUI from "./simplified-reader-ui";
import { shouldShowReadOffline } from "../../../utils/read-offline";

const Styled = {
  Container: styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background-image: linear-gradient(
      45deg,
      ${props => props.theme.vstui.color.primary.getShade(7)},
      ${props => props.theme.vstui.color.primary.getShade(5)}
    );

    @media (orientation: landscape) and (max-width: 1023px) {
      svg {
        display: none;
      }
    }
  `,
  RectangleContainer: styled.div`
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  InnerContainer: styled.div`
    padding: 10px;
    height: 100%;
    position: relative;
    z-index: 10;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    flex-direction: column;

    svg {
      margin-bottom: 15px;
    }
  `
};

class SimplifiedInterstitial extends React.Component {
  constructor() {
    super();
    this.root = document.getElementById("bookshelf");
  }

  componentDidMount() {
    if (this.root && !this.a11yDialog && this.ref) {
      this.a11yDialog = new A11yDialog(this.ref, this.root);
      this.a11yDialog.on("hide", () => {
        this.props.continueToMobileSite();
      });
      this.a11yDialog.show();
    }
  }

  continueToMobileSite() {
    if (this.a11yDialog) {
      this.a11yDialog.hide();
    }
  }

  renderUI() {
    if (shouldShowReadOffline(true)) {
      return (
        <DownloadAppUI
          continueToMobileSite={() => this.continueToMobileSite()}
        />
      );
    }

    return (
      <SimplifiedReaderUI
        continueToMobileSite={() => this.continueToMobileSite()}
      />
    );
  }

  render() {
    return (
      <Portal>
        <Styled.Container
          role="dialog"
          tabindex="-1"
          aria-labelledby="dialog-alert-title"
          aria-describedby="dialog-alert-message"
          innerRef={ref => (this.ref = ref)}
        >
          <Styled.RectangleContainer>
            <RectangleImage />
          </Styled.RectangleContainer>
          <Styled.InnerContainer>
            <DeviceImage />
            {this.renderUI()}
          </Styled.InnerContainer>
        </Styled.Container>
      </Portal>
    );
  }
}

export default withTheme(SimplifiedInterstitial);
